import { TEMPLATE_ACCENT_DEFAULTS } from '@cibli/shared';
import { z } from 'zod';

export const eleganceParamsSchema = z.object({
  accentColor: z.string().default(TEMPLATE_ACCENT_DEFAULTS.onepage),
  showProfilePicture: z.boolean().default(true),
  headerStyle: z.enum(['stripe', 'badge']).default('stripe'),
  overflowMode: z.enum(['overflow', 'clip']).default('overflow'),
  spacing: z.enum(['compact', 'normal', 'aere']).default('normal'),
});

export type EleganceParams = z.infer<typeof eleganceParamsSchema>;

export const eleganceDefaultParams: EleganceParams = eleganceParamsSchema.parse({});
